import { render, staticRenderFns } from "./FacilityTable.vue?vue&type=template&id=5d737984&scoped=true&"
import script from "./FacilityTable.vue?vue&type=script&lang=js&"
export * from "./FacilityTable.vue?vue&type=script&lang=js&"
import style0 from "./FacilityTable.vue?vue&type=style&index=0&id=5d737984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d737984",
  null
  
)

export default component.exports